<div class="maxx-monitor-form__header">
  <pdq-button
    variant="light"
    size="small"
    icon="back"
    ariaLabel="Back to monitoring"
    (onClick)="closed.emit()"></pdq-button>
  <span class="body-14-medium">{{ title }}</span>
  <span class="maxx-monitor-form__muted body-13-regular">
    MAXX checks this on your schedule and alerts you only when the condition is met.
  </span>
</div>

<div class="maxx-monitor-form__row">
  <div class="maxx-monitor-form__row-text">
    <span class="body-14-medium">Condition</span>
    <span class="maxx-monitor-form__muted body-12-regular">When MAXX should alert you.</span>
  </div>
  <div class="maxx-monitor-form__controls">
    <pdq-dropdown
      [options]="operatorOptions"
      [defaultOption]="selectedOperator()"
      [disabled]="isSaving()"
      (onChange)="select(operator, $event)"></pdq-dropdown>
    <pdq-input-arrows
      [formControl]="valueControl"
      [min]="0"
      [precision]="2"
      widthSize="xxlarge"
      [symbol]="valueSymbol()"
      [disabled]="isSaving()"></pdq-input-arrows>
    @if (showUnitToggle()) {
      <pdq-segmented-control
        [options]="unitOptions()"
        [value]="changeUnit()"
        [disabled]="isSaving()"
        (valueChange)="setChangeUnit($event)"></pdq-segmented-control>
    }
  </div>
</div>

<div class="maxx-monitor-form__row">
  <div class="maxx-monitor-form__row-text">
    <span class="body-14-medium">Schedule</span>
    <span class="maxx-monitor-form__muted body-12-regular">How often MAXX checks, and when.</span>
  </div>
  <div class="maxx-monitor-form__controls">
    <pdq-dropdown
      [options]="frequencyOptions"
      [defaultOption]="selectedFrequency()"
      [disabled]="isSaving()"
      (onChange)="select(frequency, $event)"></pdq-dropdown>
    @if (frequency() === 'weekly') {
      <pdq-dropdown
        [options]="dayOfWeekOptions"
        [defaultOption]="selectedDayOfWeek()"
        [disabled]="isSaving()"
        (onChange)="select(dayOfWeek, $event)"></pdq-dropdown>
    } @else if (frequency() === 'monthly') {
      <pdq-dropdown
        [options]="dayOfMonthOptions"
        [defaultOption]="selectedDayOfMonth()"
        [disabled]="isSaving()"
        (onChange)="select(dayOfMonth, $event)"></pdq-dropdown>
    }
    <input
      type="time"
      class="maxx-monitor-form__time body-14-regular"
      aria-label="Time"
      [value]="timeOfDay()"
      [disabled]="isSaving()"
      (change)="setTimeOfDay($event)" />
    <pdq-dropdown
      [options]="timezoneOptions()"
      [defaultOption]="selectedTimezone()"
      [disabled]="isSaving()"
      (onChange)="select(timezone, $event)"></pdq-dropdown>
  </div>
</div>

@if (slackChannelName) {
  <div class="maxx-monitor-form__row">
    <div class="maxx-monitor-form__row-text">
      <span class="body-14-medium">Slack</span>
      <span class="maxx-monitor-form__muted body-12-regular">Post each alert to #{{ slackChannelName }}.</span>
    </div>
    <pdq-slide-toggle
      [defaultValue]="postToSlack()"
      [disabled]="isSaving()"
      (onToggle)="postToSlack.set($event)"></pdq-slide-toggle>
  </div>
}

<div class="maxx-monitor-form__row">
  <div class="maxx-monitor-form__row-text">
    <span class="body-14-medium">Email recipients</span>
    <span class="maxx-monitor-form__muted body-12-regular">MAXX emails every alert to these addresses.</span>
  </div>
  <div class="maxx-monitor-form__recipients">
    <div class="maxx-monitor-form__add-recipient">
      <pdq-input
        width="240px"
        placeholder="email@example.com"
        [control]="newRecipientControl"
        [disabled]="isSaving()"
        (onEnter)="addRecipient()"></pdq-input>
      <pdq-button variant="secondary" label="Add" [disabled]="isSaving()" (onClick)="addRecipient()"></pdq-button>
    </div>
    @if (recipientError()) {
      <span class="maxx-monitor-form__error body-12-regular">{{ recipientError() }}</span>
    }
    @if (recipients().length) {
      <div class="maxx-monitor-form__chips">
        @for (email of recipients(); track email) {
          <pdq-chip [label]="email" (onChange)="removeRecipient(email)"></pdq-chip>
        }
      </div>
    }
  </div>
</div>

@if (errorMessage()) {
  <p class="maxx-monitor-form__error body-13-regular">{{ errorMessage() }}</p>
}

<div class="maxx-monitor-form__actions">
  <pdq-button variant="secondary" label="Cancel" [disabled]="isSaving()" (onClick)="closed.emit()"></pdq-button>
  <pdq-button
    variant="primary"
    [label]="monitor ? 'Save' : 'Create alert'"
    [loading]="isSaving()"
    [disabled]="!canSave()"
    (onClick)="save()"></pdq-button>
</div>
